module.exports = __webpack_public_path__ + "img/kr.d22d25fb.svg";